import BaseModel from './BaseModel';

export default class PetTrackingDeviceSubscriptionOption extends BaseModel {
  constructor(label, displayPrice, productId, billed, freeMonths, savePercent) {
    super();
    /** @type {string} **/
    this.label = label;
    /** @type {string} **/
    this.displayPrice = displayPrice;
    /** @type {int} **/
    this.productId = productId;
    /** @type {string} **/
    this.billed = billed;
    /** @type {string} **/
    this.freeMonths = freeMonths;
    /** @type {string} **/
    this.savePercent = savePercent;
  }
}
